export const PeekingSunIcon = (): JSX.Element => (
  <svg width="241" height="220" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <ellipse cx="156.5" cy="89" rx="71.5" ry="61" fill="#FDDA05" />
      <path
        d="M167.879 12.682a2 2 0 0 0-3.949.636l3.949-.636Zm-1.975.318c-1.974.318-1.974.317-1.974.316l-.001-.001v-.003l-.001-.005-.001-.006v.002l.007.057a5.887 5.887 0 0 1-.057 1.411c-.148.903-.536 1.96-1.478 2.825l2.707 2.945c1.784-1.64 2.472-3.618 2.718-5.123a9.773 9.773 0 0 0 .089-2.462 5.418 5.418 0 0 0-.02-.178l-.008-.059-.004-.021-.001-.009-.001-.004v-.001c0-.001 0-.002-1.975.316Zm-3.505 4.596c-.753.692-1.522.8-2.971.77-1.344-.028-3.528-.232-5.667.885l1.853 3.546c1.031-.54 2.017-.468 3.732-.433 1.608.034 3.786-.009 5.76-1.823l-2.707-2.945Zm-8.638 1.655c-2.142 1.12-3.496 3.088-4.122 5.076-.616 1.954-.617 4.213.328 6.018l3.544-1.855c-.33-.63-.442-1.74-.057-2.96.373-1.186 1.132-2.196 2.16-2.733l-1.853-3.546Zm-3.794 11.094c.874 1.67 1.925 2.376 2.709 2.904.633.427 1 .676 1.401 1.442l3.544-1.855c-.874-1.67-1.925-2.376-2.71-2.904-.633-.427-.999-.676-1.4-1.442l-3.544 1.855ZM152.937 4.684a2.001 2.001 0 0 0-3.744 1.409l3.744-1.41Zm-1.872.704-1.872.704-.001-.001v-.002l-.001-.002.001.002a.364.364 0 0 0 .009.027l.046.135a11.77 11.77 0 0 1 .504 2.472c.14 1.573-.095 3.04-.973 4l2.953 2.698c2.011-2.2 2.181-5.076 2.004-7.054a15.71 15.71 0 0 0-.761-3.58 6.408 6.408 0 0 1-.024-.068c-.004-.008-.006-.016-.008-.022a.095.095 0 0 0-.003-.007l-.001-.004h-.001c0-.002 0-.002-1.872.702Zm-2.287 7.335c-.371.405-.832.645-1.534.818-.852.21-1.553.235-2.822.437-1.122.18-2.449.482-3.738 1.264-1.317.799-2.458 2.011-3.37 3.797l3.562 1.82c.615-1.205 1.273-1.827 1.882-2.197.638-.387 1.369-.586 2.294-.734.778-.124 2.113-.249 3.147-.503 1.184-.291 2.458-.829 3.532-2.004l-2.953-2.698Zm-11.464 6.316c-2.095 4.101-.081 8.11 2.137 10.896 2.283 2.868 5.343 5.188 6.853 6.326l2.407-3.194c-1.529-1.152-4.202-3.2-6.13-5.622-1.992-2.503-2.665-4.707-1.705-6.586l-3.562-1.82Zm8.99 17.222c1.867 1.408 3.323 1.725 4.531 1.987 1.025.223 1.801.39 2.972 1.273l2.408-3.194c-1.868-1.408-3.324-1.725-4.532-1.987-1.024-.223-1.8-.39-2.972-1.273l-2.407 3.194Z"
        fill="#FDDA05"
      />
      <g filter="url(#b)">
        <ellipse
          cx="121"
          cy="80"
          rx="7"
          ry="5"
          fill="#FB9378"
          fillOpacity=".38"
        />
      </g>
      <g filter="url(#c)">
        <ellipse
          rx="6.693"
          ry="5.382"
          transform="matrix(.95335 -.30185 .4334 .9012 174.286 74.871)"
          fill="#FB9378"
          fillOpacity=".38"
        />
      </g>
      <path
        d="M157.84 77.154s-1.418 3.39-9.155 3.858c-7.738.467-8.899-2.767-8.899-2.767"
        stroke="#CFB202"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="133.5" cy="74.5" r="1.5" fill="#666" />
      <circle cx="162.5" cy="72.5" r="1.5" fill="#666" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M172.472 183.704C162.361 201.858 143.959 214 122.935 214c-21.553 0-40.35-12.761-50.284-31.679-5.107 3.655-11.435 5.817-18.287 5.817-13.842 0-25.544-8.825-29.37-20.951-1.649.411-3.391.631-5.192.631C9.418 167.818 1 160.512 1 151.5s8.418-16.318 18.802-16.318c4.458 0 8.554 1.347 11.777 3.597 5.617-5.99 13.745-9.754 22.785-9.754.208 0 .415.002.622.006 1.483-8.453 7.574-14.785 14.862-14.785 2.036 0 3.979.494 5.754 1.391C86.055 99.529 103.358 89 122.935 89c21.253 0 39.825 12.408 49.863 30.89a51.301 51.301 0 0 1 3.225-.102c10.913 0 20.808 3.483 28.037 9.132 3.328-1.118 7.038-1.743 10.949-1.743 14.355 0 25.991 8.409 25.991 18.781 0 10.372-11.636 18.781-25.991 18.781-.761 0-1.514-.024-2.259-.07-6.202 11.28-20.313 19.159-36.727 19.159-1.197 0-2.381-.042-3.551-.124Z"
        fill="#DFF0FC"
      />
    </g>
    <defs>
      <filter
        id="b"
        x="112"
        y="73"
        width="18"
        height="14"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="c"
        x="165.491"
        y="67.615"
        width="17.592"
        height="14.512"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h241v220H0z" />
      </clipPath>
    </defs>
  </svg>
);
